module.exports = __webpack_public_path__ + "assets/circle-check-icon.262c42e2.svg";